import React from 'react'
import { handleDataColor, replaceDotWithComma } from '../../utils'

interface CustomizedLabelGraphProps {
  x?: number
  y?: number
  value?: number
}

interface CustomizedDotProps {
  value?: number
  cx?: number
  cy?: number
}

export const CustomizedDot = ({ cx, cy, value }: CustomizedDotProps): JSX.Element => {
  const color = handleDataColor(value)

  return (
    <svg x={cx - 4} y={cy - 4} width={100} height={100} fill={color} viewBox="0 0 1024 1024">
      <circle cx="50" cy="50" r="40" stroke={color} fill={color} />
    </svg>
  )
}

export const CustomizedLabelGraph = ({
  value,
  x,
  y,
}: CustomizedLabelGraphProps): JSX.Element => {
  const formattedValue = value?.toFixed(1)

  return (
    <text
      x={x}
      y={y}
      fill={handleDataColor(value)}
      dy={-14}
      textAnchor='middle'
      fontSize={12}
      fontWeight='bold'
    >
      {replaceDotWithComma(formattedValue)}
    </text>
  )
}